/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-16 20:23:21
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types'
import s from '../form.css';
import { parseArrayToComplexTable, parseStringToArray } from '../utils';
import classnames from 'classnames';
import { getVisual } from '../../../controller';
import { drop } from 'lodash';

const defaultValue = `评测种草类	安踏	1592	62
评测种草类	李宁	2675	62
评测种草类	特步	446	48
评测种草类	耐克	14963	69
评测种草类	阿迪达斯	4594	62
评测种草类	斐乐	155	24
评测种草类	361	684	48
篮球	安踏	961	36
篮球	李宁	862	26
篮球	特步	578	22
篮球	耐克	3979	37
篮球	阿迪达斯	1760	27
篮球	斐乐	283	20
篮球	361	401	20
跑步	安踏	1704	63
跑步	李宁	2539	57
跑步	特步	953	55
跑步	耐克	8830	64
跑步	阿迪达斯	3865	52
跑步	斐乐	322	27
跑步	361	894	49
体育赛事	安踏	3407	1017
体育赛事	李宁	3932	1131
体育赛事	特步	1840	538
体育赛事	耐克	5357	1127
体育赛事	阿迪达斯	3137	748
体育赛事	斐乐	982	423
体育赛事	361	901	237
运动用品	安踏	4869	1064
运动用品	李宁	6411	1176
运动用品	特步	2232	578
运动用品	耐克	19633	1180
运动用品	阿迪达斯	7541	792
运动用品	斐乐	1130	445
运动用品	361	1548	276
`

class Form extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    children: PropTypes.node,
  }
  constructor(props) {
    super(props);

    this.state = {
      value: defaultValue,
      dataset: [],
      tableColumns: [],
      tableList: [],
      tableColorList: [],
    }
  }


  componentDidMount () {
    this.loadData();
  }

  loadData = () => {
    const { onChange } = this.props;

    getVisual('16_table').then(value => {
      const _table = Form.parse(value);

      this.setState({
        value: value,
        ..._table,
      })
  
      typeof onChange === 'function' && onChange({
        ..._table,
      });
    });
  }

  static parse = (str) => {
    const dataset = drop(parseStringToArray(str), 1);
    if (!dataset) return null;

    const { columns, list } = parseArrayToComplexTable(dataset);

    return {
      dataset,
      tableColumns: [
        {
          dataIndex: 'customKey',
          title: '类型',
          style: { width: 80, color: '#000', fontWeight: 600, fontSize: 12 },
          colStyle: { width: 80, color: '#000', fontWeight: 600, fontSize: 12 }
        },
        ...columns
      ],
      tableList: list.map((item, i) => ({ customKey: i === 0 ? '内容条数' : '账号个数', ...item })),
    }
  }
 

  onChange = (e) => {
    const { onChange } = this.props;
    const value = e.target.value;
    const tableData = Form.parse(value, this.state.tableColorList);
    this.setState({ value, ...tableData });

    typeof onChange === 'function' && onChange(tableData)
  }

  render() {
    return (
      <div className={s.root}>
        <div>数据设置</div>
        <textarea className={classnames(s.inputText)} value={this.state.value} onChange={this.onChange} />
      </div>
    );
  }
}

export default withStyles(s)(Form);



// WEBPACK FOOTER //
// src/routes/visualChart/P16/Form.js